import type { FC, ReactNode } from 'react'
import type { GetServerSideProps } from 'next'

import Link from 'next/link'
import { useRouter } from 'next/router'
import { Seo } from '@/components/generals/seo'
import AuthShell from '@/components/account/auth-shell'
import { LoginForm } from '@/components/account/auth-forms'
import { safeNext } from '@/lib/safe-redirect'

interface LoginPageProps {
    next: string
}

const LoginPage: FC<LoginPageProps> = ({ next }): ReactNode => {
    const router = useRouter()

    return (
        <AuthShell
            eyebrow='Mijn ArtDoors'
            title='Inloggen'
            description='Bekijk uw ontwerpen, offertes en de voortgang van uw deur in productie.'
        >
            <Seo title='Inloggen' noIndex />

            <LoginForm onSuccess={() => router.push(next)} />

            <p className='mt-8 border-t border-border pt-6 text-sm text-muted-foreground'>
                Nog geen account?{' '}
                <Link href={`/account/registreren${next !== '/account' ? `?volgende=${encodeURIComponent(next)}` : ''}`} className='font-medium text-foreground underline underline-offset-4'>
                    Maak er gratis een aan
                </Link>
            </p>
        </AuthShell>
    )
}

export const getServerSideProps: GetServerSideProps<LoginPageProps> = async context => {
    const { getSessionUser } = await import('@/lib/server/auth')
    const next = safeNext(context.query.volgende)
    const user = await getSessionUser(context.req)

    if (user) return { redirect: { destination: next, permanent: false } }

    return { props: { next } }
}

export default LoginPage
